export default {
  label: "Buchhaltung",
};
